import '../scss/child.scss';

jQuery(function($){

    function addBusinessDays(date, days) {

        let result = new Date(date);
        let added = 0;

        while (added < days) {

            result.setDate(result.getDate() + 1);

            if (result.getDay() !== 0 && result.getDay() !== 6) {
                added++;
            }

        }

        return result;

    }

    // Bepaal aantal werkdagen op basis van geselecteerd druktype.
    // Geen bedrukking (nvt / niets geselecteerd) = 1 werkdag, anders 5.
    function getMinDays() {
        const selected = document.querySelector('.js-product-print-type li.is-selected');
        const printType = selected?.getAttribute('data-print-type') ?? null;
        return (printType && printType !== 'nvt') ? 5 : 1;
    }

    function updateDatepicker() {
        if (!$('.delivery-datepicker').length || !$.fn.datepicker) return;

        const days    = getMinDays();
        const minDate = addBusinessDays(new Date(), days);

        $('.delivery-datepicker').datepicker('option', 'minDate', minDate);

        // Huidige waarde resetten als die voor de nieuwe minDate ligt
        const current = $('.delivery-datepicker').datepicker('getDate');
        if (!current || current < minDate) {
            $('.delivery-datepicker').datepicker('setDate', minDate);
        }
    }

    if ($(".delivery-datepicker").length && $.fn.datepicker) {

        const minDate = addBusinessDays(new Date(), getMinDays());

        $(".delivery-datepicker").datepicker({
            dateFormat:    "dd-mm-yy",
            minDate:       minDate,
            prevText:      "<",
            nextText:      ">",
            beforeShowDay: function(date) {
                let day = date.getDay();
                return [(day !== 0 && day !== 6)];
            }
        });

        $(".delivery-datepicker").datepicker("setDate", minDate);

        // Update minDate wanneer druktype wijzigt
        $(document).on('click', '.js-product-print-type li', function() {
            // Wacht één tick zodat is-selected al gezet is door product-state.js
            setTimeout(updateDatepicker, 0);
        });

    }

});
